import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import Details from "./pages/details";
import Download from "./pages/download";
import NotFound from "./pages/404";
import Media from "./pages/media";
import Dmca from "./pages/dmca";
import Contact from "./pages/contact";
import About from "./pages/about";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search/:search" element={<Home />} />
        <Route path="/category/:search" element={<Home />} />
        <Route path="/:id/:slug" element={<Details />} />
        <Route path="/:id/download" element={<Download />} />
        <Route path="/media/:url" element={<Media />} />
        <Route path="/dmca" element={<Dmca />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
